import React from "react";
import "./Projects.scss";
import des1 from "../images/des1.jpeg";
import des2 from "../images/des2.jpeg";
import des3 from "../images/des3.jpeg";
import des4 from "../images/des4.jpeg";
import des8 from "../images/des8.jpeg";
import des9 from "../images/des9.jpeg";

import mob1 from "../images/mob1.jpg";
import mob2 from "../images/mob2.jpg";
import mob3 from "../images/mob3.jpg";
import mob4 from "../images/mob4.jpg";
import mob8 from "../images/mob8.jpg";
import mob9 from "../images/mob9.jpg";

import butler1 from "../images/butler1.png";
import butler2 from "../images/butler2.png";
import butler3 from "../images/butler3.png";
import butler4 from "../images/butler4.png";
import butler5 from "../images/butler5.png";

import butlerclient1 from "../images/butlerclient1.png";
import butlerclient2 from "../images/butlerclient2.png";
import butlerclient3 from "../images/butlerclient3.png";
import butlerclient4 from "../images/butlerclient4.png";
import butlerclient5 from "../images/butlerclient5.png";

import ubr1 from "../images/ubr1.jpeg";
import ubr2 from "../images/ubr2.jpeg";
import ubr3 from "../images/ubr3.jpeg";
import ubr4 from "../images/ubr4.jpeg";
import ubr5 from "../images/ubr5.jpeg";

const Projects = () => {
  const vaccDesArray = [des1, des2, des3, des4, des8, des9];
  const vaccMobArray = [mob1, mob2, mob3, mob4, mob8, mob9];
  const butlerAdminArray = [butler1, butler2, butler3, butler4, butler5];

  const butlerClientArray = [
    butlerclient1,
    butlerclient2,
    butlerclient3,
    butlerclient4,
    butlerclient5,
  ];
  const ubrArray = [ubr5, ubr4, ubr3, ubr2, ubr1];
  return (
    <div className="proj_container" id="portfolio">
      <div className="wrap">
        <div className="girl"></div>
        <h1>
          Demo of Projects <span>.</span>
        </h1>
        <div className="list">
          <p className="proj_p">E-Vaccination Desktop</p>
          {vaccDesArray.map((item) => (
            <div className="item">
              <div
                className="img"
                style={{
                  backgroundImage: "url(" + item + ")",
                }}
              ></div>
            </div>
          ))}
          <p className="proj_p">E-Vaccination Mobile</p>
          {vaccMobArray.map((item) => (
            <div className="item">
              <div
                className="img"
                style={{
                  backgroundImage: "url(" + item + ")",
                }}
              ></div>
            </div>
          ))}
          <p className="proj_p">Butler Dashboard - Singapur Proj</p>
          {butlerAdminArray.map((item) => (
            <div className="item">
              <div
                className="img"
                style={{
                  backgroundImage: "url(" + item + ")",
                }}
              ></div>
            </div>
          ))}
          <p className="proj_p">Butler Client - Singapur Proj</p>
          {butlerClientArray.map((item) => (
            <div className="item">
              <div
                className="img"
                style={{
                  backgroundImage: "url(" + item + ")",
                }}
              ></div>
            </div>
          ))}
          <p className="proj_p">Restaurant Application Project</p>
          {ubrArray.map((item) => (
            <div className="item">
              <div
                className="img"
                style={{
                  background: "url(" + item + ") ",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
